import React, { useState, useEffect } from "react";
import "./App.css";
import { api } from "./api";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import UploadModal from "./components/UploadModal";
import CampaignView from "./components/CampaignView";
import StatusModal from "./components/StatusModal";

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("auth_token"));
  const [activeModal, setActiveModal] = useState(null); // 'upload', 'view', 'status'
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);

  const handleLogout = () => {
    api.logout();
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <Login onLoginSuccess={() => setIsAuthenticated(true)} />;
  }

  return (
    <div>
      <nav className="navbar">
        <h1>Internal SMS Gateway Dashboard</h1>
        <button className="btn btn-outline" style={{ color: "white", borderColor: "rgba(255,255,255,0.3)" }} onClick={handleLogout}>
          Logout
        </button>
      </nav>

      <main className="container">
        <Dashboard 
          onOpenUpload={() => setActiveModal("upload")}
          onViewCampaign={(id) => { setSelectedCampaignId(id); setActiveModal("view"); }}
          onOpenStatus={(id) => { setSelectedCampaignId(id); setActiveModal("status"); }}
        />
      </main>

      {activeModal === "upload" && <UploadModal onClose={() => setActiveModal(null)} onUploaded={() => setActiveModal(null)} />}
      {activeModal === "view" && <CampaignView campaignId={selectedCampaignId} onClose={() => setActiveModal(null)} />}
      {activeModal === "status" && <StatusModal campaignId={selectedCampaignId} onClose={() => setActiveModal(null)} />}
    </div>
  );
}